export default "__VITE_ASSET__BuHCUnHo__"